import React from 'react';

// this is while we don't implement the architecture of the appshell webview data comunication (CORE-3)

const withWebView = (Component) => (props) =>
    !window.ReactNativeWebView ? <Component {...props} /> : null;

export default withWebView;
